import { styled } from '@mui/material';

export const StyledSenderName = styled('p')(({ theme }) => ({
  ...theme.typography.subtitle2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  paddingTop: theme.spacing(0.5),

  margin: 0,
  whiteSpace: 'nowrap',
}));
